<template>
  <v-expand-transition>
    <div
      :id="sectionElId(section)"
      style="padding: 10px 0 10px 0;"
      v-html="displayText"
      v-if="showParagraph"
    >
    </div>
  </v-expand-transition>
</template>

<script>
import answermixin from '@/components/global/atomic/answermixin';
import { mapGetters, mapState } from 'vuex'
import GlobalConstants from '@/globals'

export default {
  name: 'UserFormParagraph',
  mixins: [answermixin],
  props: ['userFormId', 'section'],
  computed: {
    ...mapState('userform', [
      'answers'
    ]),
    ...mapGetters('userform', [
      'answer',
      'parts'
    ]),
    showParagraph() {
      return GlobalConstants.MeetsCondition(this.section, this.answer, this.parts)
    },
    displayText() {
      let text = this.section.text
      if (!text) return ''

      // Apparently, vue2's limitation in reactivity means that we need to force it to 
      // recompute every time a new answer is added. Force Update worked, but didn't respond when
      // NEW questions were answered.
      Object.keys(this.answers)

      const parser = new DOMParser()
      const doc = parser.parseFromString(text, 'text/html')
      const placeholders = doc.querySelectorAll('span[data-question-placeholder]')

      placeholders.forEach(el => {
        const qId = el.getAttribute('data-questionid')
        const fId = el.getAttribute('data-fieldtypeid')
        let ansStr = ''
        if (qId && fId) {
          const ansObj = this.answer(qId, fId, null)
          if (ansObj && ansObj.string !== undefined && ansObj.string !== null && ansObj.string !== '') {
            ansStr = ansObj.string
          }
        }
        el.replaceWith(ansStr)
      })

      return doc.body.innerHTML
    }
  },
  methods: {
    sectionElId(section) {
      return `section-${section.id}`
    }
  }
}
</script>

<style scoped>
div>>>p {
  margin: 0 !important;
}
</style>